import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { FamilyTree } from '@/components/tree';
import { Requests } from '@/components/requests';
import { SharedLinks } from '@/components/shared-links';
import { Profiles } from '@/components/profiles';
import { Users } from '@/components/users';
import { RegisterRequests } from './RegisterRequests';
import { Settings } from './settings/Settings';
import { UserRequests } from './user-requests/UserRequests';

export function Dashboard() {
  const user = useAuthStore((state) => state.user);
  const isAdmin = user?.role === 'admin';

  return (
    <div className="p-6">
      <Routes>
        <Route path="tree" element={<FamilyTree />} />
        {isAdmin ? (
          <>
            <Route path="requests" element={<Requests />} />
            <Route path="register-requests" element={<RegisterRequests />} />
            <Route path="shared" element={<SharedLinks />} />
            <Route path="users" element={<Users />} />
            <Route path="settings/*" element={<Settings />} />
          </>
        ) : (
          <Route path="requests" element={<UserRequests />} />
        )}
        <Route path="profiles" element={<Profiles />} />
        <Route path="*" element={<Navigate to="tree" replace />} />
      </Routes>
    </div>
  );
}